import * as React from 'react';

function SvgArrowDown(props) {
  return (
    <svg width={8} height={5} viewBox="0 0 8 5" fill="none" {...props}>
      <path
        d="M4.338 4.525a.462.462 0 01-.675 0L.407 1.143C.096.821.31.258.744.258h6.512c.434 0 .648.562.337.885L4.338 4.525z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgArrowDown;
